import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Components
import Navigation from './components/Navigation';
import Footer from './components/Footer';

// Pages
import Home from './Pages/Home';
import About from './Pages/About';
import Contact from './Pages/Contact';
import TalentManagement from './Pages/TalentManagement';
import EventPhotoGallery from './Pages/EventPhotoGallery'; // NEW

// Global CSS
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <CssBaseline />
      <Router>
        <div className="app-container">
          {/* <Navigation /> */}
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/talent-management" element={<TalentManagement />} />

              <Route path="/event-photo-gallery" element={<EventPhotoGallery />} />
            </Routes>
          </main>
        </div>
      </Router>
    </Provider>
  );
}

export default App;